/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SalesCategory = "AIRTIME" | "DATA" | "DSTV" | "ELECTRICITY" | "HOLLYWOOD_BETS" | "LOTTO" | "M2M" | "OTHER" | "RICA_FAILED" | "RICA_SUCCESS" | "RICA_TOTAL" | "TOTAL_SALES" | "UNIPIN" | "%future added value";
export type DashboardDataViewer_viewer = {
    readonly user: {
        readonly roles: ReadonlyArray<{
            readonly name: string;
        }>;
    } | null;
    readonly report: {
        readonly commissionSummary: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"DashboardSummary_commissionSummary">;
        }> | null;
        readonly detailedSalesReportDateRange: ReadonlyArray<{
            readonly HUBAcc: string | null;
            readonly HUB: string | null;
            readonly SpokeAcc: string | null;
            readonly Spoke: string | null;
            readonly TotalSales: number | null;
            readonly Airtime_Sales: number | null;
            readonly Data_Sales: number | null;
            readonly Electricity_Sales: number | null;
            readonly Entertainment_Sales: number | null;
            readonly Ticketing_Sales: number | null;
            readonly Billpayments_Sales: number | null;
            readonly Other_Sales: number | null;
        } | null> | null;
        readonly detailedSalesReport: ReadonlyArray<{
            readonly entity: string;
            readonly categories: {
                readonly airtime: {
                    readonly categories: ReadonlyArray<{
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    }>;
                    readonly totalRollup: {
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    };
                    readonly transactions: {
                        readonly transactionCount: number;
                        readonly transactionAmount: number;
                    };
                } | null;
                readonly data: {
                    readonly categories: ReadonlyArray<{
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    }>;
                    readonly totalRollup: {
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    };
                    readonly transactions: {
                        readonly transactionCount: number;
                        readonly transactionAmount: number;
                    };
                } | null;
                readonly entertainment: {
                    readonly categories: ReadonlyArray<{
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    }>;
                    readonly totalRollup: {
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    };
                    readonly transactions: {
                        readonly transactionCount: number;
                        readonly transactionAmount: number;
                    };
                } | null;
                readonly ticketing: {
                    readonly categories: ReadonlyArray<{
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    }>;
                    readonly totalRollup: {
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    };
                    readonly transactions: {
                        readonly transactionCount: number;
                        readonly transactionAmount: number;
                    };
                } | null;
                readonly billPayments: {
                    readonly categories: ReadonlyArray<{
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    }>;
                    readonly totalRollup: {
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    };
                    readonly transactions: {
                        readonly transactionCount: number;
                        readonly transactionAmount: number;
                    };
                } | null;
                readonly electricity: {
                    readonly categories: ReadonlyArray<{
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    }>;
                    readonly totalRollup: {
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    };
                    readonly transactions: {
                        readonly transactionCount: number;
                        readonly transactionAmount: number;
                    };
                } | null;
                readonly other: {
                    readonly categories: ReadonlyArray<{
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    }>;
                    readonly totalRollup: {
                        readonly isNull: boolean;
                        readonly name: string;
                        readonly key: string;
                        readonly yesterdaysSalesToDate: number;
                        readonly currentMonthToDate: number;
                        readonly lastMonthMonthToDate: number;
                        readonly lastMonth: number;
                    };
                    readonly transactions: {
                        readonly transactionCount: number;
                        readonly transactionAmount: number;
                    };
                } | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_report" | "DashboardProductsReport_report">;
        }> | null;
    } | null;
    readonly dashboard: {
        readonly hub: {
            readonly account: string;
            readonly categories: ReadonlyArray<{
                readonly category: SalesCategory;
                readonly " $fragmentRefs": FragmentRefs<"DashboardDataBlock_category" | "DashboardSummary_totalSales">;
            }>;
            readonly " $fragmentRefs": FragmentRefs<"DashboardSearch_account" | "DashboardSummary_accountSummary">;
        } | null;
        readonly rollup: {
            readonly account: string;
            readonly categories: ReadonlyArray<{
                readonly category: SalesCategory;
                readonly " $fragmentRefs": FragmentRefs<"DashboardDataBlock_category" | "DashboardSummary_totalSales">;
            }>;
            readonly " $fragmentRefs": FragmentRefs<"DashboardSearch_account" | "DashboardSummary_accountSummary">;
        } | null;
        readonly spokes: ReadonlyArray<{
            readonly account: string;
            readonly categories: ReadonlyArray<{
                readonly category: SalesCategory;
                readonly " $fragmentRefs": FragmentRefs<"DashboardDataBlock_category" | "DashboardSummary_totalSales">;
            }>;
            readonly " $fragmentRefs": FragmentRefs<"DashboardSearch_account" | "DashboardSummary_accountSummary">;
        }>;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AccountSelector_viewer" | "EntityCombobox_viewer" | "DashboardNegativeSummary_viewer">;
    readonly " $refType": "DashboardDataViewer_viewer";
};
export type DashboardDataViewer_viewer$data = DashboardDataViewer_viewer;
export type DashboardDataViewer_viewer$key = {
    readonly " $data"?: DashboardDataViewer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardDataViewer_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "entityReference",
  "variableName": "entityReference"
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isNull",
    "storageKey": null
  },
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "yesterdaysSalesToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentMonthToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonthMonthToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonth",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportSales",
    "kind": "LinkedField",
    "name": "categories",
    "plural": true,
    "selections": (v3/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportSales",
    "kind": "LinkedField",
    "name": "totalRollup",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportTransActions",
    "kind": "LinkedField",
    "name": "transactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionAmount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "account",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DashboardCategorySales",
    "kind": "LinkedField",
    "name": "categories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DashboardDataBlock_category"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DashboardSummary_totalSales"
      }
    ],
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DashboardSearch_account"
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DashboardSummary_accountSummary"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "endDate"
    },
    {
      "kind": "RootArgument",
      "name": "entityReference"
    },
    {
      "kind": "RootArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardDataViewer_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Report",
      "kind": "LinkedField",
      "name": "report",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "CommissionSummary",
          "kind": "LinkedField",
          "name": "commissionSummary",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DashboardSummary_commissionSummary"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "endDate",
              "variableName": "endDate"
            },
            (v1/*: any*/),
            {
              "kind": "Variable",
              "name": "startDate",
              "variableName": "startDate"
            }
          ],
          "concreteType": "DetailedSalesReportDateRange",
          "kind": "LinkedField",
          "name": "detailedSalesReportDateRange",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "HUBAcc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "HUB",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "SpokeAcc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Spoke",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "TotalSales",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Airtime_Sales",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Data_Sales",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Electricity_Sales",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Entertainment_Sales",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Ticketing_Sales",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Billpayments_Sales",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Other_Sales",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "DetailedSalesReport",
          "kind": "LinkedField",
          "name": "detailedSalesReport",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DetailedSalesReportCategories",
              "kind": "LinkedField",
              "name": "categories",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DetailedSalesReportCategory",
                  "kind": "LinkedField",
                  "name": "airtime",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DetailedSalesReportCategory",
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DetailedSalesReportCategory",
                  "kind": "LinkedField",
                  "name": "entertainment",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DetailedSalesReportCategory",
                  "kind": "LinkedField",
                  "name": "ticketing",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DetailedSalesReportCategory",
                  "kind": "LinkedField",
                  "name": "billPayments",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DetailedSalesReportCategory",
                  "kind": "LinkedField",
                  "name": "electricity",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DetailedSalesReportCategory",
                  "kind": "LinkedField",
                  "name": "other",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DashboardDropDown_report"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DashboardProductsReport_report"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "dashboard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DashboardHubAccount",
          "kind": "LinkedField",
          "name": "hub",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DashboardHubAccount",
          "kind": "LinkedField",
          "name": "rollup",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DashboardSpokeAccount",
          "kind": "LinkedField",
          "name": "spokes",
          "plural": true,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountSelector_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityCombobox_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardNegativeSummary_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = 'b56fa19e58aab5b7cec7fb6ee42cc8b5';
export default node;
